<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <h1>Logout</h1>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: 'Logout',
  data () {
      return {
          loading: false
      }
  },
  created() {
    const user = this.$cookies.get('user');
    this.$gtag.event('logout', {
      event_category: 'auth_events',
      event_label: 'Admin logout',
      user_type: 'admin',
      user_id: user?._id,
    });
    this.logout();

    localStorage.removeItem("user");
    localStorage.removeItem("token_device");
    localStorage.removeItem("token");
    localStorage.removeItem("x_csrf_token");
    localStorage.removeItem("flag_token");

    let flag_token = localStorage.getItem('flag_token_logout');

    if (flag_token == null || flag_token === "" || flag_token === 0) {
      localStorage.setItem("flag_token_logout", 1);
      location.reload();
    } else {

      this.$router.push("/login");
    }


  },
  methods:{
      logout() {
        try {
          const token = this.$cookies.get('token');

          axios.post(this.$configs.api + '/api/v4/cp/admin/logout', {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });
          this.$cookies.remove('token')
          this.$cookies.remove('user')

        } catch (err) {
          console.log(err);
        }
      }
  }
}
</script>
